import { render, staticRenderFns } from "./AdminHr.vue?vue&type=template&id=53eb60f2&scoped=true&"
import script from "./AdminHr.vue?vue&type=script&lang=js&"
export * from "./AdminHr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb60f2",
  null
  
)

export default component.exports